import request from "@/utils/request";
// 生成海报
export function generalImage(data) {
  return request({
    url: "/generalImage",
    method: "post",
    data,
  });
}
// 生成文案
export function generalRefineTxt(data) {
  return request({
    url: "/generalRefineTxt",
    method: "post",
    data,
  });
}

export function checkVip(data) {
	return request({
		url: "/common/check",
		method: "post",
		data,
	});
}

export function getSysEnum(data) {
	return request({
		url: "/sys/getSysEnum",
		method: "get",
		params: data,
	});
}

export function getTopic(data) {
	return request({
		url: "/note/getTopic",
		method: "get",
		params: data,
	});
}

export function createNote(data) {
	return request({
		url: "/note/create",
		method: "post",
		data,
	});
}

export function rewrite(data) {
	return request({
		url: "/note/rewrite",
		method: "post",
		data,
	});
}

export function historyImg(data) {
	return request({
		url: "/ai/poster/result/page",
		method: "post",
		data,
	});
}

export function historyNote(data) {
	return request({
		url: "/note/pageList",
		method: "post",
		data,
	});
}

export function saveScript(data) {
	return request({
		url: "/script/save",
		method: "post",
		data,
	});
}

export function scriptCreate(data) {
	return request({
		url: "/script/aicreate",
		method: "post",
		data,
	});
}

export function scriptPageList(data) {
	return request({
		url: "/script/pageList",
		method: "post",
		data,
	});
}

export function scriptDelete(data) {
	return request({
		url: "/script/delete",
		method: "post",
		data,
	});
}

export function textTime(data) {
	return request({
		url: "/videoRetalk/text2Time",
		method: "post",
		data,
	});
}

//分片上传初始化
export function getInitApi(data) {
	return request({
		url: "/voice-upload/fileUploadInit",
		method: "post",
		data,
	});
}
//分片上传获取每一片地址
export function getPartUrlApi(data) {
	return request({
		url: "/voice-upload/fileUploadAuth",
		method: "post",
		data,
	});
}
//分片上传合成
export function completeApi(data) {
	return request({
		url: "/voice-upload/fileUploadMulti",
		method: "post",
		data,
	});
}

//上传第一帧图片(视频封面)
export function uploadCoverImage(data) {
  return request({
    url: "/voice-upload/firstImageUpload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data", // 上传文件通常需要这个
    },
  });
}